import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { useAetherLabels } from '#pplx/frontend/aether/internal/labels/useAetherLabels.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import * as Dialog from '@radix-ui/react-dialog';
export function ModalCloseButton() {
    const { close: closeLabel } = useAetherLabels();
    return (_jsx("div", { className: "absolute top-4 right-4 z-10", children: _jsx("div", { className: "mt-1 mr-2", children: _jsx(Dialog.Close, { asChild: true, children: _jsx(Button, { icon: $icon('x'), "aria-label": closeLabel, size: "small", variant: "secondary", rounded: true }) }) }) }));
}
//# sourceMappingURL=ModalCloseButton.js.map